import { CLIENTES_ANALISES_MERCADOS_API_RESOURCE } from '../consts';

/** Resource da API das Análises de Mercados RAP */
export const CLIENTES_ANALISES_MERCADOS_RAP_API_RESOURCE = `${CLIENTES_ANALISES_MERCADOS_API_RESOURCE}/rap`;
